import * as React from 'react';
export const lclSvg = React.forwardRef(function lclSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#21368B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm23 20 .3-.11c-1.09 0-2.3-.73-2.3-1.78V11h2v8h6v1h-6ZM6 20l.3-.11c-1.09 0-2.3-.73-2.3-1.78V11h2v8h6v1H6Zm14-1.82v1.36a9.06 9.06 0 0 1-2.54.35c-3.51 0-6.35-2.01-6.35-4.45 0-2.44 2.84-4.44 6.35-4.44a9.002 9.002 0 0 1 2.55.36v1.42a8.944 8.944 0 0 0-2.67-.89 3.23 3.23 0 0 0-3.55 3.55A3.23 3.23 0 0 0 17.34 19a8.319 8.319 0 0 0 2.66-.82Z',
      fill: '#FFD200',
    }),
  );
});
lclSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lcl = {
  category: 'brand',
  colorable: false,
  name: 'lcl',
  svg: lclSvg,
};
